import { FC } from 'react'

import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { SecondText } from '../../style'
import { ReviewTheDepositActivityOutStateProps } from './ReviewTheDepositActivityOutStateProps'

export const ReviewTheDepositActivityOutState: FC<ReviewTheDepositActivityOutStateProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <SecondText>Review the deposit activity for out-of-state checks.</SecondText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewTheDepositActivityOutState"
          label="Were there out-of-state checks deposited?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Yes – See comments',
                value: 'yes'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions'
              },
              {
                label: 'No Transactions of this Type',
                value: 'no_transactions'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Col>
          <Field
            name="reviewTheDepositActivityAddressed"
            label="If noted, how was the activity addressed?"
            input={Select}
            inputProps={{
              data: [
                {
                  label: 'N/A',
                  value: 'n/a'
                },
                {
                  label: 'Transaction cleared with communication to customer during review',
                  value: 'cleared'
                },
                {
                  label: 'Transaction added to Annual Review questions',
                  value: 'added'
                }
              ]
            }}
          />
        </Col>
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewTheDepositActivityComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
